import React from 'react';
import HeroSection from '../sections/ResidentParcelDashboardSection/HeroSection/HeroSection';

function About() {
  return (
    <div>
      <HeroSection title="About Us" subtitle="Learn more about what we do." />
      <p style={{ padding: "20px" }}>We are a leading company in tech world.</p>
    </div>
  );
}

export default About;
